import { Component } from '@angular/core';

@Component({
  selector: 'app-azure-login',
  templateUrl: './azure-login.component.html'
})
export class AzureLoginComponent {
}
